// src/utils/toast.ts
export type ToastType = 'success' | 'error' | 'info' | 'warning';

export function showToast(type: ToastType, message: string, duration = 3500): void {
  let container = document.getElementById('toast-container');

  // Nếu chưa có container trên DOM, tự động tạo mới
  if (!container) {
    container = document.createElement('div');
    container.id = 'toast-container';
    container.style.cssText = `
      position: fixed;
      top: 24px;
      right: 24px;
      z-index: 99999;
      display: flex;
      flex-direction: column;
      gap: 10px;
      max-width: 380px;
      pointer-events: none;
    `;
    document.body.appendChild(container);

    // Chèn Keyframe animation nếu chưa có
    if (!document.getElementById('toast-style')) {
      const style = document.createElement('style');
      style.id = 'toast-style';
      style.innerHTML = `
        @keyframes toastIn {
          from { opacity: 0; transform: translateX(100%); }
          to { opacity: 1; transform: translateX(0); }
        }
      `;
      document.head.appendChild(style);
    }
  }

  // Cấu hình Icon & Màu sắc theo Type
  let iconClass = 'fa-info-circle';
  let borderColor = '#17a2b8';

  if (type === 'success') {
    iconClass = 'fa-check-circle';
    borderColor = '#28a745';
  } else if (type === 'error') {
    iconClass = 'fa-exclamation-circle';
    borderColor = '#dc3545';
  } else if (type === 'warning') {
    iconClass = 'fa-exclamation-triangle';
    borderColor = '#ffc107';
  }

  // Tạo thẻ Toast Item
  const toast = document.createElement('div');
  toast.style.cssText = `
    pointer-events: auto;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    color: #333333;
    font-size: 14px;
    font-family: inherit;
    border-left: 4px solid ${borderColor};
    animation: toastIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
    transition: all 0.3s ease;
  `;

  toast.innerHTML = `
    <i class="fas ${iconClass}" style="color: ${borderColor}; font-size: 18px; flex-shrink: 0;"></i>
    <div style="flex: 1; line-height: 1.4; word-break: break-word; font-weight: 500;">${message}</div>
    <button type="button" style="background: none; border: none; color: #aaa; cursor: pointer; padding: 0 0 0 8px; font-size: 18px; line-height: 1;">&times;</button>
  `;

  // Nút đóng nhanh
  const closeBtn = toast.querySelector('button');
  closeBtn?.addEventListener('click', () => removeToast(toast));

  container.appendChild(toast);

  // Tự động tắt sau khoảng thời gian `duration`
  setTimeout(() => {
    removeToast(toast);
  }, duration);
}

function removeToast(toast: HTMLElement) {
  toast.style.opacity = '0';
  toast.style.transform = 'translateX(100%)';
  setTimeout(() => {
    toast.remove();
  }, 300);
}